// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Classnames$GearCalculator = require("../Utils/Classnames.bs.js");

function Content(Props) {
  var children = Props.children;
  var className = Props.className;
  return React.createElement("div", {
              className: Classnames$GearCalculator.make(/* :: */[
                    "content",
                    /* :: */[
                      Classnames$GearCalculator.unpack(className),
                      /* [] */0
                    ]
                  ])
            }, children);
}

var make = Content;

exports.make = make;
/* react Not a pure module */
